// extracted by mini-css-extract-plugin
export default {"checkbox":"_2ywhQ","align-items-center":"wy9eD","alignItemsCenter":"wy9eD","label":"_1XTFG"};